const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  email: state => state.user.email,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  errorLogs: state => state.errorLog.logs,
  expiryTime: state => state.user.expiryTime,
  uuid: state => state.user.uuid,
  ssoConfigs: state => state.facets.ssoConfigs,
}
export default getters
